<template>
  <div>
    <d-form @submit="sendNewPass">
      <d-form-row>
        <d-col class="header">
          <h4>{{ $t('recoverPassword.title') }}</h4>
        </d-col>
      </d-form-row>

      <d-form-row>
        <!-- E-mail -->
        <d-col class="form-group">
          <label for="email">
            {{ $t('recoverPassword.form.email.label') }}
          </label>
          <d-form-input
            type="email"
            :placeholder="$t('recoverPassword.form.email.placeholder')"
            v-model="form.email"
            required
          />
        </d-col>
      </d-form-row>

      <d-form-row>
        <!-- Senha -->
        <d-col class="form-group">
          <label for="username">
            {{ $t('recoverPassword.form.newPassword.label') }}
          </label>
          <d-form-input
            type="password"
            :placeholder="$t('form.password.placeholder')"
            v-model="form.newPassword"
            required
          />
        </d-col>
      </d-form-row>

      <d-form-row>
        <!-- Confirmar Senha -->
        <d-col class="form-group">
          <label for="username">
            {{ $t('recoverPassword.form.confirmPassword.label') }}
          </label>
          <d-form-input
            @keydown.enter="sendNewPass()"
            type="password"
            :placeholder="$t('form.password.placeholder')"
            v-model="form.confirmNewPassword"
            ref="confirmPass"
            required
          />
          <d-form-invalid-feedback>
            {{ $t('recoverPassword.form.confirmPassword.invalid') }}
          </d-form-invalid-feedback>
        </d-col>
      </d-form-row>

      <d-form-row class="login-form__form__control control">
        <d-col class="control__error" cols="12">
          <span v-if="error">{{ error }}</span>
        </d-col>
        <d-col class="control__send" cols="12">
          <router-link
            :to="{ path: '/public/login' }"
            class="control__send__back-login"
          >
            {{ $t('recoverPassword.login') }}
          </router-link>
          <div class="control__send__button">
            <loader v-if="loading" :fullPage="false" class="mr-4" />
            <d-button type="submit" class="btn btn-md btn-primary">
              {{ $t('recoverPassword.form.submit') }}
            </d-button>
          </div>
        </d-col>
      </d-form-row>
    </d-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import AuthService from '_services/rest/auth';
import Loader from '_shared/Loader.vue';

export default {
  name: 'recover-password',
  components: {
    Loader,
  },
  data() {
    return {
      form: {
        newPassword: null,
        confirmNewPassword: null,
        token: this.$route.params.token,
      },
      loginForm: {
        username: null,
        password: null,
      },
      loading: false,
      error: null,
    };
  },
  methods: {
    ...mapActions(['login', 'activeAlert']),
    sendNewPass(e) {
      e.preventDefault();
      this.error = false;
      this.loading = true;

      if (this.form.newPassword && this.form.confirmNewPassword) {
        if (this.form.newPassword !== this.form.confirmNewPassword) {
          this.error = this.$t('recoverPassword.errors.passwordsDoNotMatch');
          this.loading = false;
          return;
        }

        AuthService.recoverPassword(this.form)
          .then(() => {
            this.loading = false;
            this.activeAlert({
              message: this.$t('recoverPassword.successMessage'),
              theme: 'success',
            });
            this.$router.push('/public/login');
          })
          .catch(error => {
            this.loading = false;
            this.activeAlert({ message: `${error.message}`, theme: 'danger' });
          });

        return;
      }

      this.error = this.$t('recoverPassword.errors.typeNewPassword');
      this.loading = false;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.login-form {
  width: 100%;
  justify-content: center;
  .control {
    &__send {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      &__button {
        display: flex;
        justify-content: flex-end;
      }
    }
    &__error {
      color: $red;
    }
  }
}
</style>
